var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 4.00004H15.82C15.93 3.69004 16 3.35004 16 3.00004C16.0011 2.35486 15.7939 1.72657 15.4092 1.20863C15.0245 0.690689 14.4829 0.310766 13.8649 0.125376C13.2469 -0.0600139 12.5856 -0.0409654 11.9794 0.179688C11.3731 0.400342 10.8542 0.810811 10.5 1.35004L10 2.02004L9.5 1.34004C8.96 0.540037 8.05 3.75273e-05 7 3.75273e-05C5.34 3.75273e-05 4 1.34004 4 3.00004C4 3.35004 4.07 3.69004 4.18 4.00004H2C0.89 4.00004 0.00999999 4.89004 0.00999999 6.00004L0 17C0 18.11 0.89 19 2 19H18C19.11 19 20 18.11 20 17V6.00004C20 4.89004 19.11 4.00004 18 4.00004ZM13 2.00004C13.55 2.00004 14 2.45004 14 3.00004C14 3.55004 13.55 4.00004 13 4.00004C12.45 4.00004 12 3.55004 12 3.00004C12 2.45004 12.45 2.00004 13 2.00004ZM7 2.00004C7.55 2.00004 8 2.45004 8 3.00004C8 3.55004 7.55 4.00004 7 4.00004C6.45 4.00004 6 3.55004 6 3.00004C6 2.45004 6.45 2.00004 7 2.00004ZM18 17H2V15H18V17ZM18 12H2V6.00004H7.08L5 8.83004L6.62 10L10 5.40004L13.38 10L15 8.83004L12.92 6.00004H18V12Z",
    fill: "#FF7235"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.09e37ae4d02799b62fd72f02403abe9d.svg";
export { ForwardRef as ReactComponent };